import { UserDataType } from '@/types/UserDataType.type';
import * as constants from '../constants/user.constants';

interface UserType extends UserDataType {
  accessToken: string;
}

interface UserState {
  user: UserType | null;
  cart: any;
}

const initialState: UserState = {
  user: null,
  cart: null,
};

export const userReducer = (state = initialState, action: any): UserState => {
  switch (action.type) {
    case constants.USER_DATA:      
      return {
        ...state,
        user: action.payload,
      };
    case constants.CART_DATA:
      return {
        ...state,
        //cart: action.payload,
        cart: {
          // Ticket selection, date and time actions don't always pass an
          // eventId - fall back to whatever event the cart already belonged
          // to so the cart stays scoped to one event at a time.
          eventId: action.payload.eventId ?? state.cart?.eventId,
          selectedTickets: action.payload.selectedTickets,
          selectedDate: action.payload.selectedDate,
          selectedTime: action.payload.selectedTime,
        },
      };
    case constants.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
